<template>
    <div
        :class="[checkSizable(sizable), checkHoverAvailable(isHoverAvailable)]"
        class="list-items c2 badges"
    >
        <div
            v-for="(row, index) in rows"
            :key="index"
            class="item"
        >
            <span class="left">{{ row.name }}</span>
            <span
                v-for="(item, idxItem) in row.items"
                :key="idxItem"
                class="right"
            >
                <span v-if="row.component === 'ValueEmpty'">
                    <ValueEmpty
                        :text="item.textNone ? item.textNone : ''"
                        :value="item.value"
                    ></ValueEmpty>
                </span>
                <span v-else-if="row.component === 'BadgeTotal'">
                    <BadgeTotal
                        :convert-negative="item.convertNegative"
                        :symbol="item.symbol"
                        :title="item.title"
                        :color="item.color"
                        :value="item.value"
                    ></BadgeTotal>
                </span>
                <span v-else-if="row.component === 'ValueYesNo'">
                    <ValueYesNo :value="item.value"></ValueYesNo>
                </span>
                <span v-else>
                    <EmptyBadge
                        :color="item.color"
                        :value="item.value"
                    ></EmptyBadge>
                </span>
            </span>
            <div class="clearfix"></div>
            <div
                v-if="row.progress !== null && row.progress !== undefined"
                class="progress progress-primary no-margin"
            >
                <div
                    :aria-valuenow="row.progress"
                    :style="{ width: `${row.progress}%` }"
                    aria-valuemax="100"
                    aria-valuemin="0"
                    class="progress-bar progress-bar-primary progress-bar-striped active"
                    role="progressbar"
                >
                    <div class="progress-bar-value">{{ row.progress }}%</div>
                </div>
            </div>
            <hr
                v-if="index < rows.length - 1"
                class="mb0 mt5"
            />
        </div>
    </div>
</template>

<script>
import ValueEmpty from '../subcomponents/ValueEmpty';
import BadgeTotal from '../subcomponents/BadgeTotal';
import ValueYesNo from '../subcomponents/ValueYesNo';
import EmptyBadge from '../subcomponents/EmptyBadge';

export default {
    components: {
        ValueEmpty,
        ValueYesNo,
        BadgeTotal,
        EmptyBadge,
    },
    props: {
        rows: Array,
        sizable: Boolean,
        isHoverAvailable: Boolean,
    },
    methods: {
        log(data) {
            return typeof data;
        },
        checkSizable: function (value) {
            return value === true ? 'sizable' : '';
        },
        checkHoverAvailable: function (value) {
            return value === true ? 'hoverable' : '';
        },
    },
};
</script>
